import React, { useState, useEffect } from "react";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DataPickerButton from "react-multi-date-picker/components/button";

const CustomDateInputs = ({
  type,
  startDateAndTime,
  endDateAndTime,
  setSelectedStartDateAndTime,
  setSelectedEndDateAndTime,
  setSelectedOption,
  setSoundDataType,
  setCount,
  count,
  excelLoading,
  downloadExcelReport,
  setSensorType,
  sensorType,
  isKit,
  setPageNumber,
  soundDataType,
  selectedOption,
  parameter,
  setParameter,
  setSoundChartType,
  onApply,
}) => {
  const firstDate = new Date("2024-01-17");
  const todayDate = new Date();

  const handleOnClick = () => {
    setSelectedStartDateAndTime(startDateAndTime);
    setSelectedEndDateAndTime(endDateAndTime);
    if (onApply) {
      onApply(startDateAndTime, endDateAndTime);
    }
    setCount(count + 1);
    setPageNumber(1);
  };

  useEffect(() => {
    if (parameter === "spl" && soundDataType !== "spl") {
      setParameter("leq");
    }

    if (parameter === "leq" && soundDataType === "spl") {
      setParameter("spl");
    }
  }, [soundDataType]);

  return (
    <div className="col-lg-3 col-xl-2 my-5">
      <div className="bg-secondary p-2">
        <div>
          <div className="my-5 mx-auto d-flex justify-content-center ">
            <label className="text-light" htmlFor="average">
              شروع بازه
            </label>
            <DatePicker
              value={startDateAndTime}
              onChange={setSelectedStartDateAndTime}
              minDate={firstDate}
              maxDate={todayDate}
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              hideOnScroll
              render={
                <DataPickerButton
                  className="text-light mx-1 bg-dark rounded-1"
                  placeholder="انتخاب"
                />
              }
              format="HH:mm:ss   YYYY/MM/DD"
              plugins={[<TimePicker position="bottom" />]}
            />
          </div>
          <div className="my-5 mx-auto d-flex justify-content-center ">
            <label className="text-light mx-1" htmlFor="average">
              پایان بازه
            </label>
            <DatePicker
              value={endDateAndTime}
              onChange={setSelectedEndDateAndTime}
              minDate={startDateAndTime}
              maxDate={todayDate}
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              hideOnScroll
              render={
                <DataPickerButton
                  className="text-light bg-dark rounded-1"
                  placeholder="انتخاب"
                />
              }
              format="HH:mm:ss   YYYY/MM/DD"
              plugins={[<TimePicker position="bottom" />]}
              style={{ whiteSpace: "pre-line" }}
            />
          </div>
        </div>

        {type && type === "air" ? (
          <div className="mx-auto d-flex justify-content-center align-items-center">
            <label className="text-light" htmlFor="aqiType">
              نوع میانگین
            </label>

            <select
              className="mx-1"
              name="aqiType"
              id="aqiType"
              onChange={(e) => setSelectedOption(e.target.value)}
            >
              <option value="hourly">شاخص ساعتی</option>
              {sensorType !== "environment" ? (
                <>
                  <option value="daily">شاخص روزانه</option>
                  <option value="online">شاخص 3 دقیقه ای</option>
                  <option value="twelve">شاخص هم اکنون</option>
                  <option value="twentyFour">شاخص آنلاین</option>
                </>
              ) : null}
            </select>
          </div>
        ) : (
          ""
        )}

        {type && (type === "sound" || type === "soundChart") ? (
          <div className="mx-auto d-flex justify-content-center align-items-center">
            <label className="text-light" htmlFor="leqType">
              نوع میانگین
            </label>

            <select
              className="mx-1"
              name="leqType"
              id="leqType"
              onChange={(e) => setSoundDataType(e.target.value)}
            >
              <option value="spl">SPL</option>
              <option value="hourly">LEQ ساعتی</option>
              <option value="nighttime">LEQ شبانه</option>
              <option value="daytime">LEQ روزانه</option>
              <option value="daily">LEQ شبانه روز</option>
            </select>
          </div>
        ) : (
          ""
        )}

        {type && type === "soundChart" ? (
          <div className="mx-auto my-5 d-flex justify-content-center align-items-center">
            <label className="text-light" htmlFor="leqType">
              انتخاب پارامتر
            </label>

            <select
              className="mx-1"
              name="leqType"
              id="leqType"
              onChange={(e) => setParameter(e.target.value)}
            >
              {soundDataType === "spl" && <option value="spl">SPL</option>}
              {soundDataType !== "spl" && <option value="leq">LEQ</option>}
              {soundDataType !== "spl" && soundDataType !== "hourly" && (
                <>
                  <option value="leq_min">LEQ_min</option>
                  <option value="leq_max">Leq_max</option>
                </>
              )}
            </select>
          </div>
        ) : (
          ""
        )}

        {type && type === "soundChart" ? (
          <div className="mx-auto my-5 d-flex justify-content-center align-items-center">
            <label className="text-light" htmlFor="leqType">
              انتخاب نوع نمودار
            </label>

            <select
              className="mx-1"
              name="leqType"
              id="leqType"
              onChange={(e) => setParameter(e.target.value)}
            >
              <option value="Line">نمودار خطی</option>
              <option value="Bar">نمودار میله ای</option>
            </select>
          </div>
        ) : (
          ""
        )}

        {isKit ? (
          <div className="mx-auto d-flex justify-content-center align-items-center mt-5">
            <label className="text-light" htmlFor="aqiType">
              نوع سنسور
            </label>

            <select
              className="mx-1"
              name="sensor"
              id="sensor"
              value={sensorType} // Bind the value of the select to the state `sensorType`
              onChange={(e) => setSensorType(e.target.value)} // Update the state with the selected value
            >
              <option value="pollution">سنسور اصلی</option>
              <option value="environment">سنسور کیت</option>
            </select>
          </div>
        ) : (
          ""
        )}

        <div className="d-flex flex-wrap justify-content-center mt-4 mb-3">
          <div>
            <button
              className="btn btn-primary btn-large my-3"
              onClick={handleOnClick}
            >
              اعمال فیلتر جستجو
            </button>
          </div>

          {type && type !== "soundChart" && type !== "OPSGA105" && (
            <div>
              {excelLoading ? (
                <button
                  className={`btn btn-success btn-large px-5 my-3 mx-1`}
                  onClick={() => downloadExcelReport()}
                >
                  <span className="spinner spinner-border spinner-border-sm"></span>
                </button>
              ) : (
                // Render the button when not loading
                <button
                  className="btn btn-success btn-large my-3 mx-1"
                  onClick={() => downloadExcelReport()}
                >
                  دریافت گزارش اکسل
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomDateInputs;
